import { frontendURL } from '../../../../helper/URLHelper';
import {
  CANNED_RESPONSE_MANAGE_PERMISSIONS,
  CANNED_RESPONSE_CREATE_PERMISSIONS,
  CANNED_RESPONSE_EDIT_PERMISSIONS,
  CANNED_RESPONSE_DELETE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const CannedHome = () => import('./Index.vue');

const CANNED_MANAGEMENT_PERMISSIONS = [
  'administrator',
  CANNED_RESPONSE_MANAGE_PERMISSIONS,
  CANNED_RESPONSE_CREATE_PERMISSIONS,
  CANNED_RESPONSE_EDIT_PERMISSIONS,
  CANNED_RESPONSE_DELETE_PERMISSIONS,
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/automations/canned-response'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'canned_list',
          meta: {
            permissions: CANNED_MANAGEMENT_PERMISSIONS,
          },
          component: CannedHome,
        },
      ],
    },
  ],
};
